import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { getIsWhitelabel } from '../selectors/view';

const Overlay = ({ isWhitelabel }) => (
  <div className="search-page__overlay">
    <div className="overlay_container">
      {isWhitelabel ? (
        <div className="throbber">
          <div className="spinner" />
        </div>
      ) : (
        <div className="lt-preloader-logo">
          <div className="lt-preloader-logo__sun-mask">
            <div className="lt-preloader-logo__sun" />
          </div>
          <div className="lt-preloader-logo__wave" />
          <div className="lt-preloader-logo__wave__2" />
          <div className="lt-preloader-logo__wave__3" />
        </div>
      )}

      <div className="ovelay_message_title">Применяем фильтр</div>
      <div className="ovelay_message">
        Вы можете продолжать
        <br />
        добавлять фильтры
      </div>
    </div>
  </div>
);

Overlay.propTypes = {
  isWhitelabel: PropTypes.bool,
};

Overlay.defaultProps = {
  isWhitelabel: false,
};

const mapStateToProps = (state) => ({
  isWhitelabel: getIsWhitelabel(state),
});

export default connect(mapStateToProps)(Overlay);
